import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from "../../../config";
import { FaArrowTrendUp, FaArrowTrendDown, FaWallet, FaMoneyBillWave } from "react-icons/fa6";

const ProfitLoss = () => {
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchFinancials = async () => {
    try {
      const token = localStorage.getItem("token");

      const [incomeRes, expenseRes] = await Promise.all([
        axios.get(`${API_URL}/api/income`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API_URL}/api/expense`, { headers: { Authorization: `Bearer ${token}` } })
      ]);

      let tIncome = 0;
      if (incomeRes.data.success) {
        tIncome = incomeRes.data.incomes.reduce((sum, inc) => sum + Number(inc.amount || 0), 0);
        setTotalIncome(tIncome);
      }

      let tExpense = 0;
      if (expenseRes.data.success) {
        tExpense = expenseRes.data.expenses.reduce((sum, exp) => sum + Number(exp.amount || 0), 0);
        setTotalExpenses(tExpense);
      }

    } catch (error) {
      console.error('Error fetching financials:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFinancials();
  }, []);

  const profitLoss = totalIncome - totalExpenses;
  const isProfit = profitLoss >= 0;

  return (
    <div style={{ padding: '30px', backgroundColor: '#f4f7fb', minHeight: '80vh', fontFamily: "'Inter', sans-serif" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1a2233', margin: 0 }}>Profit & Loss Report</h2>
      </div>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
          <div style={{ padding: '20px', borderRadius: '12px', background: '#fff', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', fontSize: '18px', color: '#666' }}>
            Loading financial data...
          </div>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '24px', maxWidth: '1100px' }}>

          {/* Income Card */}
          <div style={{
            background: 'linear-gradient(135deg, #ffffff 0%, #f9fbfd 100%)',
            borderRadius: '16px',
            padding: '28px',
            boxShadow: '0 8px 20px rgba(0,0,0,0.04)',
            border: '1px solid rgba(40,167,69,0.2)',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{ position: 'absolute', top: '-10px', right: '-10px', opacity: 0.04 }}>
              <FaArrowTrendUp size={120} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'rgba(40,167,69,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#28a745' }}>
                <FaArrowTrendUp size={24} />
              </div>
              <h3 style={{ margin: 0, color: '#6c757d', fontSize: '15px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Income</h3>
            </div>
            <h2 style={{ margin: 0, color: '#1a2233', fontSize: '38px', fontWeight: '800' }}>₹{totalIncome.toLocaleString('en-IN')}</h2>
            <p style={{ margin: '12px 0 0 0', color: '#28a745', fontSize: '14px', fontWeight: '500' }}>Total revenue generated</p>
          </div>

          {/* Expenses Card */}
          <div style={{
            background: 'linear-gradient(135deg, #ffffff 0%, #fdf9f9 100%)',
            borderRadius: '16px',
            padding: '28px',
            boxShadow: '0 8px 20px rgba(0,0,0,0.04)',
            border: '1px solid rgba(220,53,69,0.2)',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{ position: 'absolute', top: '-10px', right: '-10px', opacity: 0.04 }}>
              <FaArrowTrendDown size={120} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'rgba(220,53,69,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#dc3545' }}>
                <FaArrowTrendDown size={24} />
              </div>
              <h3 style={{ margin: 0, color: '#6c757d', fontSize: '15px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Expenses</h3>
            </div>
            <h2 style={{ margin: 0, color: '#1a2233', fontSize: '38px', fontWeight: '800' }}>₹{totalExpenses.toLocaleString('en-IN')}</h2>
            <p style={{ margin: '12px 0 0 0', color: '#dc3545', fontSize: '14px', fontWeight: '500' }}>Total operational costs</p>
          </div>

          {/* Net Profit Card */}
          <div style={{
            background: isProfit ? 'linear-gradient(135deg, #1e7e34 0%, #28a745 100%)' : 'linear-gradient(135deg, #bd2130 0%, #dc3545 100%)',
            borderRadius: '16px',
            padding: '28px',
            boxShadow: isProfit ? '0 10px 25px rgba(40,167,69,0.3)' : '0 10px 25px rgba(220,53,69,0.3)',
            display: 'flex',
            flexDirection: 'column',
            color: '#fff',
            gridColumn: '1 / -1',
            position: 'relative',
            overflow: 'hidden',
            marginTop: '10px'
          }}>
            <div style={{ position: 'absolute', right: '-20px', bottom: '-20px', opacity: 0.15 }}>
              <FaMoneyBillWave size={150} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <h3 style={{ margin: 0, color: 'rgba(255,255,255,0.9)', fontSize: '16px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>
                {isProfit ? 'Net Profit' : 'Net Loss'}
              </h3>
            </div>
            <h1 style={{ margin: 0, color: '#fff', fontSize: '56px', fontWeight: '900', letterSpacing: '-1px' }}>
              ₹{Math.abs(profitLoss).toLocaleString('en-IN')}
            </h1>
            <p style={{ margin: '16px 0 0 0', color: 'rgba(255,255,255,0.8)', fontSize: '15px' }}>
              {isProfit ? 'Great job! You have a positive cash flow.' : 'Attention needed. Your expenses exceed your income.'}
            </p>
          </div>

        </div>
      )}
    </div>
  );
};

export default ProfitLoss;
